import { UiSuspensefulOutlet } from '@experiences/ui-common';
import type { UiRouteObject } from '@experiences/util';
import type { PropsWithChildren } from 'react';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { routePaths } from '../../common/constants/routePaths';
import { useOrganizationName } from '../../common/hooks/useOrganizationName';
import BreadcrumbProvider from '../../common/providers/BreadcrumbProvider';
import { useTenantIdContext } from '../../common/providers/TenantIdProvider';
import EdgeSettingsPageComponent from './EdgeSettingsViewComponent';
import RegisterEdgeComponent from './RegisterEdge';

const EdgeSettingsProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const { formatMessage: translate } = useIntl();
    const organizationName = useOrganizationName();
    const { tenantName } = useTenantIdContext();

    const breadCrumbLinks = useMemo(() => [
        {
            index: 0,
            link: routePaths.admin,
            name: organizationName,
        },
        {
            index: 1,
            link: routePaths.adminTenantHome,
            name: tenantName,
        },
        {
            index: 2,
            link: routePaths.adminTenantEdge,
            name: translate({ id: 'CLIENT_EDGE' }),
        },
        {
            index: 3,
            link: routePaths.adminTenantEdgeAdd,
            name: translate({ id: 'CLIENT_ADD_EDGE' }),
        },
    ],
    [ organizationName, tenantName, translate ]);

    return <BreadcrumbProvider breadcrumbs={breadCrumbLinks}>
        {children}
    </BreadcrumbProvider>;

};

export const EdgeSettingsRoutes: UiRouteObject = {
    path: routePaths.adminTenantEdge,
    element: <EdgeSettingsProvider>
        <UiSuspensefulOutlet />
    </EdgeSettingsProvider>,
    children: [
        {
            index: true,
            element: <EdgeSettingsPageComponent />,
        },
        {
            path: routePaths.adminTenantEdgeAdd,
            element: <RegisterEdgeComponent />,
        },
    ],
};
